
<template>
  <!-- 基础资料 -->
  <div>
    <el-tabs type="border-card">
      <el-tab-pane label="供应商管理">
        <Supplier></Supplier>
      </el-tab-pane>
      <el-tab-pane label="商品信息管理">
      <Merchandise></Merchandise>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import Supplier from "./Supplier";
import Merchandise from "./Merchandise";
export default {
  name: "SlmsData",
  components: {
    Supplier,
    Merchandise
  },
  data() {
    return {};
  },

  mounted() {},

  methods: {},
};
</script>

<style lang="scss" scoped>
</style>